var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGetListItem = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M9.825 10.5a.45.45 0 0 0 0 .9h4.35a.45.45 0 0 0 0-.9zm-.45 2.55a.45.45 0 0 1 .45-.45h3.825a.45.45 0 0 1 0 .9H9.825a.45.45 0 0 1-.45-.45m0 2.1a.45.45 0 0 1 .45-.45H12.9a.45.45 0 0 1 0 .9H9.825a.45.45 0 0 1-.45-.45m6.721 2.07v-3.008a.3.3 0 0 1 .116-.24.44.44 0 0 1 .288-.097q.172 0 .288.097a.3.3 0 0 1 .116.24v3.009l1.153-.961a.4.4 0 0 1 .283-.097.47.47 0 0 1 .283.097.32.32 0 0 1 .127.24.29.29 0 0 1-.116.24l-1.85 1.542a.4.4 0 0 1-.132.072.53.53 0 0 1-.304 0 .4.4 0 0 1-.131-.072l-1.85-1.542a.29.29 0 0 1-.117-.24.32.32 0 0 1 .127-.24.47.47 0 0 1 .283-.097.4.4 0 0 1 .283.097z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M16.5 6.75h-2.895a1.576 1.576 0 0 0-3.06 0H7.5A1.5 1.5 0 0 0 6 8.25v8.25A1.5 1.5 0 0 0 7.5 18h5.4a.45.45 0 1 0 0-.9H7.5a.6.6 0 0 1-.6-.6V8.25a.6.6 0 0 1 .6-.6h1.125v.6c0 .414.336.75.75.75h5.25a.75.75 0 0 0 .75-.75v-.6H16.5a.6.6 0 0 1 .6.6v3.525a.45.45 0 1 0 .9 0V8.25a1.5 1.5 0 0 0-1.5-1.5m-4.425.9a.525.525 0 1 0 0-1.05.525.525 0 0 0 0 1.05",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGetListItem);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/get-list-item.5f29ba4d.svg";